import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'

const Confirmig = (props) => {
    const { id, scroll } = props

    const getImagenes = graphql`
    {
        pagador:file(relativePath: {eq: "pagador.png"}) {
            childImageSharp {
                fluid(maxWidth: 200) {
                    ...GatsbyImageSharpFluid
                }
            }
        }

        factoring:file(relativePath: {eq: "factoring.png"}) {
            childImageSharp {
                fluid(maxWidth: 200) {
                    ...GatsbyImageSharpFluid
                }
            }
        }

        proveedor:file(relativePath: {eq: "proveedor.png"}) {
            childImageSharp {
                fluid(maxWidth: 200) {
                    ...GatsbyImageSharpFluid
                }
            }
        }

    }`

    const { pagador, factoring, proveedor } = useStaticQuery(getImagenes);

    return (
        <section className="page-section" >
            <div className="name-section" id={id}>
                <Container>
                    <Row className="">
                        <Col lg={6} md={6}>
                            <h2 className="mt-0 title-general">¿Qué es el confirming?</h2>
                            <hr className="divider-2 my-4" />
                            <p className="mb-4 pr-4" >
                                Es el proceso que utilizan empresas que deben cancelar grandes volúmenes de facturas a múltiples proveedores a tráves de un intermediario financiero. La empresa deudora entrega a una entidad financiera una cartera de documentos confirmados a pago, cediendole la obligación de pago, con el compromiso de cancelar el total de las facturas financiadas en un pago consolidado a futuro. Lo anterior permite que la empresa deudora simplifique su gestión de pago y los acreedores puedan recibir sus pagos en plazos de tiempo más cortos.
                        </p>
                            <a className="btn btn-outline-primary js-scroll-trigger no-movil" href="#sobre"
                                onClick={scroll}>Conocer cómo funciona Confirmae
                        </a>
                        </Col>
                        <Col lg={6} md={6}>
                            <h2 className="mt-0 title-general">Actores</h2>
                            <hr className="divider-2 my-4" />
                            <Row className="actor">
                                <Col sm={2}>
                                    <div className="contenedor-img">
                                        <Image fluid={pagador.childImageSharp.fluid} />
                                    </div>
                                </Col>
                                <Col sm={10}>
                                    <h5 className="title-general color-pagador">PAGADOR</h5>
                                    <p>
                                        Empresa deudora obligada al pago de grandes volúmenes de facturas de compra a múltiples proveedores, que negocia mediante Confirming que el pago lo efectúe un Factoring.
                                </p>
                                </Col>
                            </Row>
                            <Row className="actor">
                                <Col sm={2}>
                                    <div className="contenedor-img">
                                        <Image fluid={factoring.childImageSharp.fluid} />
                                    </div>
                                </Col>
                                <Col sm={10}>
                                    <h5 className="title-general color-factoring">FACTORING</h5>
                                    <p>
                                        Entidad financiera que se hace responsable de pagar una cartera de deuda por cuenta del PAGADOR y cobra posteriormente a éste los documentos financiados.
                                </p>
                                </Col>
                            </Row>
                            <Row className="actor">
                                <Col sm={2}>
                                    <div className="contenedor-img">
                                        <Image fluid={proveedor.childImageSharp.fluid} />
                                    </div>
                                </Col>
                                <Col sm={10}>
                                    <h5 className="title-general color-proveedor">PROVEEDOR</h5>
                                    <p>
                                        Empresa acreedora que previa cesión recibe de un Factoring el pago de las facturas que le adeuda un PAGADOR
                                </p>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default Confirmig
